// src/components/SubHeader.jsx
import React from "react";
import { useLocation, Location } from "react-router-dom";
import { Box } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import useLocale from "../hooks/useLocale";
import { findRouteByPath } from "../routes";


// スタイルの定義
const useStyles = createStyles((theme) => ({
  subheader: {
    backgroundColor: "var(--accent-bg)",
    textAlign: "center",
    padding: `${theme.spacing.xl} ${theme.spacing.md}`,
    marginBottom: theme.spacing.xl,
  },
  title: {
    margin: 0,
    fontWeight: 700, // ボールド（太字）に変更
    fontSize: "1.75rem",
    color: "var(--accent-text)",
    letterSpacing: "0.01em",
    '@media (max-width: 768px)': {
      fontSize: theme.fontSizes.md, // 元のサイズに近づける
    },
  },
}));

function SubHeader() {
  const { classes } = useStyles();
  const location: Location = useLocation();
  const t = useLocale();
  const matchedRoute = findRouteByPath(location.pathname);
  const pageName = matchedRoute?.titleKey ? t.subheader[matchedRoute.titleKey] : "";

  // ページ名が無ければサブヘッダー自体を表示しない例
  if (!pageName) return null;

  return (
    <Box className={classes.subheader}>
      <h2 className={classes.title} style={{ fontWeight: 700 }}>{pageName}</h2>
    </Box>
  );
}

export default SubHeader;
